import { overrideBaseLocale } from './base-config';
export var jaJP = overrideBaseLocale('ja-JP', {});
//# sourceMappingURL=ja-JP.js.map